import React from "react";
import { GreenTickIcon, WhatsappTemplateSucessIllustration } from "../../icon";
import ButtonComponent from "../shared/button/button.component";
import { useNavigate } from "react-router";
import { AppRoutes } from "../routes/route.path";


const AddWhatsappTemplateSuccess = () => {

    const navigate = useNavigate()
    return (
        <div className='w-p-100 h-p-100 bg-color-grid d-flex justify-center align-center'>
            <div className='w-p-96 h-p-96 bg-color-secondary br-2 d-flex flex-direction align-center '>
                <div className="w-p-86 h-10 d-flex justify-center align-center h4-semibold color-nav-bar-font-color mx-auto mb-8">
                    <GreenTickIcon className="w-2 h-2 mr-1" />
                    <div className="color-add-whatsapp-template-stepper-sucess">
                        Set up Template&nbsp;&nbsp;
                    </div>
                    <div className="bb-bottom-nav-bar-font-color w-2">

                    </div>
                    <GreenTickIcon className="w-2 h-2 mx-1" />
                    <div className="color-add-whatsapp-template-stepper-sucess">
                        Edit & Preview&nbsp;&nbsp;
                    </div>
                    <div className="bb-bottom-nav-bar-font-color w-2">

                    </div>
                    <GreenTickIcon className="w-2 h-2 mx-1" />
                    <div className="color-add-whatsapp-template-stepper-sucess">
                        Submit for review
                    </div>
                </div>
                <div className="d-flex justify-center my-2">
                    <WhatsappTemplateSucessIllustration />
                </div>
                <div className="h-6 h5-semibold d-flex justify-center align-center">
                    Your template is sent to review
                </div>
                <div className="d-flex justify-center align-center">
                    <ButtonComponent ButtonLabel={"Back to Templates"} Variant={"primary-btn"} OnClick={() => {navigate(AppRoutes.TEMPLATES) }} />
                </div>
            </div>
        </div>
    )
}

export default AddWhatsappTemplateSuccess;